import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import TrainRecordNew from './components/TrainRecordNew'
import {
  getPersonalApprovalSinglePackageList,
  getEmployeeDetail,
  getCoursebypackagebagFromHome,
  getEnterpriseStudyList,
  getQualityAndIntensiveCourseList,
  getTrainingRecordPackagebagList,
  getTrainingRecord,
  getEmployeeStudyList,
  getMustAndStartingCourse,
  getExerciseRecordList,
  examRecordList,
  getPersonalCheckPackagebagList,
  exerciseErrorsList,
  getExamRecordsForReviewOrg,
  exerciseDetail,
  commitApprovalPackageRecords
} from "@/apiCloud/studyCentre";
import {
  getEntpExerciseConfigCurrent,
  exerciseDetailVerification
} from "@/apiCloud/examList"
import {
  getEmployeeInformation
} from "@/apiCloud/userCenter";
import {mapGetters} from 'vuex'
import store from '@/store'

export default {
  components: {
    myHeader,
    myFooter,
    TrainRecordNew
  },
  data() {
    return {
      // 2种培训记录的请求状态，用于监听
      requestObj:{
        type0:false,
        type1:false,
      },
      trainType:0,
      nowTime: "",
      timeStart: "",
      timeEnd: "",
      canAnyTimeExam: "",
      canLateDelay: "",
      passScore: "",
      score: "",
      activeName: "one",
      detailByTrain: false,
      dialogVisible: false,
      img_photoUrl: "", //查看图片的路径
      img_showBig: false, //查看图片的显隐
      userSturyTotalHourse: '0时0分0秒', //在线累计时长
      onlineCourse: 0, //在学课程
      studyType: null, //是否学完
      exercise: true,
      studyCentreList: [],
      isStudiedList: [{
          title: '待学习',
          value: 0
        },
        {
          title: '学习中',
          value: 2
        },
        {
          title: '已学完',
          value: 1
        }
      ],
      pageSize: 16,
      pageNum: 1,
      total: 0, //分页的总条数
      empHeadportrait: '', //头像
      empName: '', //姓名
      empTel: '', //员工电话
      // empOnlinetime:0,
      // studingCourse:0,
      deptName: '', //组织机构
      // empIssueCourse:'',  //已开通课
      publicCourseList: [ //公共课程部分数据
        {
          title: "必学课程",
        }
      ],
      packagebagList: [],
      myExerciseList: [],
      exerciseErrorsList: [],
      optionsExercise: [{

        value: '0',
        label: '模拟考试'
      }, {
        value: '1',
        label: '练习题库'
      }, ],
      value: '',
      pageNo: 1,
      count: 10,
      exercisePageSize: 10,
      exerciseTotal: 0,
      exercisePageNum: 1,
      exerciseType: '',
      packageSelected: '0',
      packagebagId: '',
      allCourseList: [],
      packagebagStatus: 0,
      pastCentreList: [],
      pastPackagebagList: [],
      studyTypeL: '',
      pastPackagebagId: '',
      isJx: false,
      regId: '',
      courseType: "专业课程",
      courseType2: "专业课程",
      trainRecordForm: {
        trainingShcoolName: "",
        orderPackagebagName: "",
        overStatus: "",
        pageNum: 1,
        pageSize: 10
      }, //培训记录搜索条件
      majorList: [{
        label: "未学习",
        value: "0"
      }, {
        label: "已学完",
        value: "1"
      }, {
        label: "学习中",
        value: "2"
      }, {
        label: "未分课",
        value: "3"
      }, {
        label: "已作废",
        value: "5"
      }, ],
      learningStateList: [{
          label: "待学习",
          value: "0",
        },
        {
          label: "学习中",
          value: "1",
        },
        {
          label: "已学完",
          value: "2",
        },
      ],
      trainData: [], //培训记录表格数据
      checkTrainDetail: false, //查看培训记录详情弹框,
      TrainDetailData: [], //培训记录详情表格数据
      testRecordList: [], //考试记录
      examineForm: {
        status: "",
        pageNum: 1,
        pageSize: 10
      }, //审核列表查询条件
      examineFormList: [{
          label: "通过",
          value: 0,
        },
        {
          label: "不通过",
          value: 1,
        },
        {
          label: "待审核",
          value: 2,
        },
        {
          label: "未提交",
          value: 3,
        },
      ],
      examineFormDate: [], //我的审核表格数据
      detail_examine: false,
      detail_examineForm: {
        tableData_test: [],
        tableData_study: [],
      }, //审核详情的所有数据
      personForm: {
        empHeadportrait: "",
        empIdcardFront: "",
        empIdcardNegative: "",
      },
      personMassage: {
        empHeadportrait: "",
        empIdcardFront: "",
        empIdcardNegative: "",
      },
      exerciseIdOneMore: "",
      courseIdOneMore: "",
      noticeContent: "",
      detailByTrainData: [],
      testListTotal: 0,
      trainListTotal: 0,
      detailByTrainForm: {
        courseName: "",
        state: "",
        pageNum: 1,
        pageSize: 10,
        statbagId: "",
        empId: "",
        packagebagId: "",
      },
      testedForm: {
        pageNum: 1,
        pageSize: 10
      },
      examinedForm: {
        pageNum: 1,
        pageSize: 10
      },
      examineListTotal: 0,
    }
  },
  computed:{
    ...mapGetters(['entpType']),
    viewExercisePhotos(){
      return this.$store.state.enterprise.otherConfig.viewExercisePhotos
    }
  },
  watch:{
    requestObj:{
      deep: true,
      handler(val){
        console.log(val)
        if(val.type0 && val.type1){

          if(this.trainData.length ===0 && this.$refs.TrainRecordNew.recordList.length>0){
            this.trainType = 1
          }
        }
      }
    }
  },
  // 历史遗留问题，等待获取配置信息
  beforeRouteEnter(to, from, next){
    let waitTime = 0
    if(store.getters.entpType != ''){
      next()
      return
    }
    let t = setInterval(()=>{
      waitTime+=1
      if(waitTime==20 || store.getters.entpType != ''){
        console.log('wait',waitTime)
        clearInterval(t)
        t= null
        next()
      }
    },300)
  },
  created() {
    this.getEmployeeDetail()
    this.getStudyTime()
    // this.isRecordListOrErrorsList()
    this.getMyCoursePackage(0)
    this.getTrainList()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    //     var pUrl=window.location.href;
    //    // 是否是江西代理商访问
    //        if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //        console.log(1111,this.isJx)
    //        this.isJx=true;
    //    }
    // this.getPackagebag(0)
    // this.getPackagebag(1)
  },
  mounted() {
    var publicCourse = document.getElementById("studyCentre")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 250 + "px"
  },
  methods: {
    formatterOverStatus(row) {
      if (row.overStatus == 0) {
        return "未学习"
      } else if (row.overStatus == 1) {
        return "已学完"
      } else if (row.overStatus == 2) {
        return "学习中"
      } else if (row.overStatus == 3) {
        return "未分课"
      } else if (row.overStatus == 4) {
        return "已作废"
      }
    },
    formatterExamResult(row) {
      if (row.examOver == 0) {
        return "不合格"
      } else if (row.examOver == 1) {
        return "合格"
      } else if (row.examOver == 2) {
        return "无考试"
      } else if (row.examOver == 3) {
        return "未考完"
      } else if (row.examOver == 4) {
        return "不审核"
      }

    },
    formatterCourseOver(row) {
      // return row.courseOver == 1 ? "已学完" : "未学习"
      if (row.courseOver == 0) {
        return "未学习"
      }
      if (row.courseOver == 1) {
        return "已学完"
      }
      if (row.courseOver == 2) {
        return "学习中"
      }
      if (row.courseOver == 3) {
        return "未分课"
      }
      if (row.courseOver == 4) {
        return "已作废"
      }
    },
    overStatusFormatter(row) {
      // return row.overStatus == 1 ? "已学完" : "未学习"
      if (row.overStatus == 0) {
        return "未学习"
      }
      if (row.overStatus == 1) {
        return "已学完"
      }
      if (row.overStatus == 2) {
        return "学习中"
      }
      if (row.overStatus == 3) {
        return "未分课"
      }
      if (row.overStatus == 4) {
        return "已作废"
      }
    },
    stateFormatter(row) {
      if (row.state == 0) {
        return "未学习"
      }
      if (row.state == 1) {
        return "已学完"
      }
      if (row.state == 2) {
        return "学习中"
      }
      if (row.state == 3) {
        return "未分课"
      }
      if (row.state == 4) {
        return "已作废"
      }
    },

    //培训记录完成状态
    courseOverTrainFormatter(row) {
      if (row.overStatus == null) {
        return "未学习"
      }
      if (row.overStatus == 0) {
        return "学习中"
      }
      if (row.overStatus == 1) {
        return "已学完"
      }
      if (row.overStatus == 3) {
        return "未分课"
      }
      if (row.overStatus == 4) {
        return "已作废"
      }
    },
    courseOverFormatter(row) {
      if (row.courseOver == null) {
        return "未学习"
      }
      if (row.courseOver == 0) {
        return "学习中"
      }
      if (row.courseOver == 1) {
        return "已学完"
      }
      if (row.courseOver == 3) {
        return "未分课"
      }
      if (row.courseOver == 4) {
        return "已作废"
      }
    },
    invalidFormatter(row) {
      if (row.invalid == 0) {
        return "通过"
      }
      if (row.invalid == 1) {
        return "不通过"
      }
      if (row.invalid == 2) {
        return "待审核"
      }
    },
    //查看详情弹窗
    checkExamineDatil(row) {
      this.detail_examine = true
      this.getOneIdCardPhoto(row.empId)
      this.getPhotoTable(row.empId, row.packagebagId)
      let data = {}
      data.statbagId = row.statbagId
      getPersonalApprovalSinglePackageList(data).then(res => {
        this.detail_examineForm.tableData_study = res.data
        for(let i =0;i<this.detail_examineForm.tableData_study.length;i++){
          if (this.detail_examineForm.tableData_study[i].photoList.length > 0) {
            for(let j =0;j<this.detail_examineForm.tableData_study[i].photoList.length;j++){
              this.detail_examineForm.tableData_study[i].photoList[j]=this.detail_examineForm.tableData_study[i].photoList[j].photoUrl
            }
          }
        }
      })
    },
    //获取身份证照片
    getOneIdCardPhoto(id) {
      let data = {};
      data.empId = id;
      getEmployeeDetail(data).then((res) => {
        this.personForm.empHeadportrait = res.data.empHeadportrait;
        this.personForm.empIdcardFront = res.data.empIdcardFront;
        this.personForm.empIdcardNegative = res.data.empIdcardNegative;
      });
    },
    //单个审核获取考试照片表格
    getPhotoTable(empId, packagebagId) {
      let data = {};
      data.userId = empId;
      data.packagebagId = packagebagId;
      getExamRecordsForReviewOrg(data).then((res) => {
        this.detail_examineForm.tableData_test = res.data
      });
    },
    //提交审核操作
    comfirmExamine(row) {
      this.$confirm('确认提交审核?', '提交审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          statbagId: row.statbagId,
          packagebagId: row.packagebagId
        }
        commitApprovalPackageRecords(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.getMyExamineList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    },
    handleDetailDate() {
      let data = this.detailByTrainForm
      getTrainingRecord(data).then(res => {
        this.detailByTrainData = res.data
      })
    },
    //查看详情操作
    clickDetail(row) {
      this.detailByTrain = true
      this.detailByTrainForm.packagebagId = row.packagebagId
      this.detailByTrainForm.empId = row.empId
      this.detailByTrainForm.statbagId = row.statbagId
      let data = {
        packagebagId: row.packagebagId,
        empId: row.empId,
        statbagId: row.statbagId,
        // pageSize: 10,
        // pageNum: 1
      }
      getTrainingRecord(data).then(res => {
        this.detailByTrainData = res.data
      })
    },
    checkTrainPhoto(row) {
      this.checkTrainDetail = true
      this.getUserPhotoList()
      this.getCourseDetailList(row.courseId, row.regId, row.empId)
    },
    //获取个人照片和身份证照片
    getUserPhotoList() {
      let data = {}
      let isEntp = this.entpType =='2'
      getTrainingRecordPackagebagList(data,isEntp).then(res => {
        this.personMassage = res.data[0]
      })
    },
    getImgList(photoList, index) {
      let arr = []
      if (photoList.length == 1) {
        arr.push(photoList[0])
      } else if (photoList.length == 0)  {
        return arr;
      } else {
        for(let i = 0;i < photoList.length;i++){
          arr.push(photoList[i+index])
          if(i+index >= photoList.length-1){
            index = 0-(i+1);
          }
        }
      }
      return arr;
    },
    //获取课程学习列表
    getCourseDetailList(courseId, regId, empId) {
      let data = {}
      data.courseId = courseId
      data.regId = regId
      data.empId = empId
      getEmployeeStudyList(data).then(res => {
        this.TrainDetailData = res.data
        for(let i =0;i<this.TrainDetailData.length;i++){
          if (this.TrainDetailData[i].photoList.length > 0) {
            for(let j =0;j<this.TrainDetailData[i].photoList.length;j++){
              this.TrainDetailData[i].photoList[j]=this.TrainDetailData[i].photoList[j].photoUrl
            }
          }
        }
      })
    },
    getImgList(photoList, index) {
      let arr = []
      if (photoList.length == 1) {
        arr.push(photoList[0])
      } else if (photoList.length == 0)  {
        return arr;
      } else {
        for(let i = 0;i < photoList.length;i++){
          arr.push(photoList[i+index])
          if(i+index >= photoList.length-1){
            index = 0-(i+1);
          }
        }
      }
      return arr;
    },
    //获取个人信息
    getEmployeeDetail() {
      getEmployeeInformation().then(res => {
        if (res.code == 200) {
          let data = res.data
          if (!res.data.empHeadportrait || res.data.empHeadportrait == "" || res.data.empHeadportrait == null) {
            this.empHeadportrait = "../../static/empHeadportrait.png"
          } else {
            this.empHeadportrait = res.data.empHeadportrait
          }
          this.empName = data.empName
          this.empTel = data.empTel ? data.empTel : '暂无'
          this.deptName = data.deptName ? data.deptName : '暂无'
        }
      })
    },
    //获取学习时长
    getStudyTime() {
      getMustAndStartingCourse().then(res => {
        if (res.success) {
          this.userSturyTotalHourse = res.data.userSturyTotalHourse
          this.onlineCourse = res.data.onlineCourse
        }
      })
    },
    //我的课程
    getMyCoursePackage(packagebagStatus) {
      if(packagebagStatus==0){
        this.courseType = '专业课程'
      }
      if(packagebagStatus==1){
        this.courseType2 = '专业课程'
      }
      this.packagebagStatus = packagebagStatus
      let data = {
        packagebagStatus
      }
      let isEntp = this.entpType =='2'
      getCoursebypackagebagFromHome(data,isEntp).then(res => {
        if (res.success) { //我的课程包
          if (packagebagStatus == 0) {
            this.packagebagList = res.data
            this.packagebagList.forEach((item, index) => {
              item['active'] = 0
              if (index == 0) {
                item.active = 1
              }
            })
            if (res.data.length > 0) {
              this.packagebagId = res.data[0].packagebagId;
              this.regId = res.data[0].regId;
              this.getCourse()
            } else {
              this.allCourseList = []
              this.studyCentreList = []
            }
          } else { //过期课程包
            this.pastPackagebagList = res.data
            this.pastPackagebagList.forEach((item, index) => {
              item['active'] = 0
              if (index == 0) {
                item.active = 1
              }
            });
            if (res.data.length > 0) {
              this.pastPackagebagId = res.data[0].packagebagId;
              this.regId = res.data[0].regId;
              this.getPastCourse()
            } else {
              this.pastCentreList = []
            }
          }

        } else {
          this.$message.error(res.message)
        }
      })

    },
    getCourse(studyType) { //课程列表
      let data = {
        packagebagId: this.packagebagId,
        regId: this.regId
      }
      let isEntp = this.entpType =='2'
      getEnterpriseStudyList(data,isEntp).then(res => {
        if (res.success) {
          if (!studyType) {
            this.studyCentreList = res.data
            this.allCourseList = res.data
          } else {
            this.allCourseList = res.data
            let allCourseList = []
            this.allCourseList.forEach((item) => {
              if (item.studyType == studyType) {
                allCourseList.push(item)
              }
            })
            this.studyCentreList = allCourseList
          }

        }
      })
    },
    getPastCourse() { //过期课程列表
      let data = {
        packagebagId: this.pastPackagebagId,
        regId: this.regId
      }
      let isEntp = this.entpType =='2'
      getEnterpriseStudyList(data,isEntp).then(res => {
        if (res.success) {
          this.pastCentreList = res.data
        }
      })
    },
    //课程包选择
    packagebagSelect(row) {
      this.studyType = null
      this.packagebagId = row.packagebagId;
      this.regId = row.regId;
      this.packagebagList.forEach((item, index) => {
        if (item.regId == row.regId) {
          item.active = 1
        } else {
          item.active = 0
        }
      })
      this.getCourse()
    },
    //过期课程包选择
    pastPackagebagSelect(row) {
      this.pastPackagebagList.forEach((item, index) => {
        if (item.regId == row.regId) {
          item.active = 1
        } else {
          item.active = 0
        }
      })
      this.pastPackagebagId = row.packagebagId
      this.getPastCourse()
    },
    studied(value) { //根据学习状态获取学习列表
      this.studyType = value
      this.studyCentreList = []
      this.allCourseList.forEach((item) => {
        if (item.studyType == value) {
          this.studyCentreList.push(item)
        }
      })
    },
    //查看考试结果
    checkTestDetail(exerciseId, detailShow, passScore) {
      if (detailShow == 2) {
        this.$router.push({
          path: "/testResult",
          query: {
            exerciseId: exerciseId
          }
        });
      } else {
        this.$router.push({
          path: "/otherTestRerult",
          query: {
            exerciseId: exerciseId,
            detailShow: detailShow,
            passScore: passScore
          }
        });
      }
    },
    // //课程包
    // getPackagebag(packagebagStatus){
    //     console.log(1111)
    //     let url="home/getCoursebypackagebagFromHome"
    //     let data={
    //         packagebagStatus
    //     }
    //     getCourseList(url,data).then(res=>{
    //         if(res.success){
    //             this.packageSelected=0 //默认第一个
    //             this.packagebagList=res.data
    //             this.packagebagId=res.data[0].packagebagId
    //             if(packagebagStatus==0){
    //                 this.packagebagList=res.data
    //                 this.getStudyCentreList(0)
    //             }else{
    //                 this.pastPackagebagList=res.data
    //                 this.getStudyCentreList(1)
    //             }
    //         }
    //     })
    // },
    // packagebagSelect(packagebagId,index){
    //     this.studyType=null
    //     this.packagebagId=packagebagId
    //     this.packageSelected=index
    //     this.getStudyCentreList()
    // },
    //获取课程列表
    // getStudyCentreList(packagebagStatus){
    //     let url="home/getEnterpriseStudyList"
    //     let data={
    //         packagebagId:this.packagebagId,
    //     }
    //     getCourseList(url,data).then(res=>{
    //         if(res.success){
    //             if(packagebagStatus==0){
    //                 this.allCourseList=res.data
    //                 this.studied()
    //             }else{
    //                 this.pastCentreList=res.data
    //             }
    //         }else{
    //             this.$message.error(res.message)
    //         }
    //     })
    // },

    currentChange(page) {
      this.pageNum = page
      this.getStudyCentreList()
    },
    handleClick(tab, event) {
      if (tab.label == "我的课程") {
        this.getMyCoursePackage(0)
      } else if (tab.label == "过期课程") {
        this.getMyCoursePackage(1)
      } else if (tab.label == "培训记录") {
        this.getTrainList()
      } else if (tab.label == "练习记录") {
        this.getExerciseRecordList()
      } else if (tab.label == "考试记录") {
        this.getExamList()
      } else if (tab.label == "我的审核") {
        this.getMyExamineList()
      }
    },
    //获取考试记录
    getExamList() {
      let data = this.testedForm
      examRecordList(data).then(res => {
        if (res.code == 200) {
          this.testRecordList = res.data
          for (let i = 0; i < this.testRecordList.length; i++) {
            let time1 = Date.parse(new Date(this.testRecordList[i].beginDateTime))
            let time2 = Date.parse(new Date(this.testRecordList[i].assignmentTime))
            let time3 = parseInt((time2 - time1) / 1000 / 60)
            let time4 = (time2 - time1) / 1000 - time3 * 60
            this.testRecordList[i].timeUsed = time3 + "分" + time4 + "秒"
          }
          this.testListTotal = res.total
        }
      })
    },
    //我的审核列表
    getMyExamineList() {
      let data = this.examinedForm
      console.log('我的审核列表', data)
      getPersonalCheckPackagebagList(data).then(res => {
        if (res.success) {
          this.examineFormDate = res.data
          this.examineListTotal = res.total
        }
      })
    },
    //培训记录搜索
    trainingRecordsSearch() {
      this.getTrainList();
    },
    //我的培训列表
    getTrainList() {
      let data = this.trainRecordForm
      let isEntp = this.entpType =='2'
      getTrainingRecordPackagebagList(data,isEntp).then(res => {
        if (res.code == 200) {
          this.trainData = res.data
          this.trainListTotal = res.total
          if(!this.requestObj.type0){
            this.requestObj.type0 = true
          }
        }
      })
    },
    changeRequestObj(){
      if(!this.requestObj.type1){
        this.requestObj.type1 = true
      }
    },
    myExercise() {
      this.exercise = true
      this.exerciseType = ""
      this.exercisePageNum = 1
      this.exerciseTotal = 0
      this.getExerciseRecordList()
    },
    myMistakes() {
      this.exercise = false
      this.exercisePageNum = 1
      this.exerciseTotal = 0
      this.getExerciseErrorsList()
    },
    GotoCourseDetail(id, regId,entpId) {
      this.$router.push({
        path: "/courseDetail",
        params: {
          courseId: id,
          packagebagId: this.packagebagId,
          courseType: this.courseType,
          regId: this.regId,
          studyEntpId: entpId
        },
        query:{
          studyEntpId: entpId
        }
      });
      sessionStorage.setItem('returnRouteBack', 'StudyCentre')
      localStorage.setItem("studyPackagebagId", this.packagebagId);
      localStorage.setItem("studyRegId", this.regId);
      localStorage.setItem("courseId", id)
      localStorage.setItem("courseType", this.courseType)
    },
    // 我的练习--练习记录
    getExerciseRecordList() {
      let data = {
        exerciseType: this.exerciseType,
        pageNum: this.exercisePageNum,
        pageSize: this.exercisePageSize
      };
      getExerciseRecordList(data).then(res => {
        // console.log(11111,res)
        if (res.success) {
          let data = res.data
          data.forEach((item) => {
            let startTime = new Date(item.beginDateTime).getTime()
            let stopTime = new Date(item.assignmentTime).getTime()
            let timeA = stopTime - startTime
            var hours = parseInt((timeA % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = parseInt((timeA % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = (timeA % (1000 * 60)) / 1000;
            var answerTime = hours + "小时" + minutes + "分" + seconds + "秒"
            item['answerTime'] = answerTime

          }, this);
          this.myExerciseList = data
          this.exerciseTotal = res.total
        }
      })
    },
    // 我的练习--我的错题
    getExerciseErrorsList() {
      let data = {
        pageNum: this.exercisePageNum,
        pageSize: this.exercisePageSize
      };
      exerciseErrorsList(data).then(res => {
        // console.log(111111,res)
        if (res.success) {
          this.exerciseErrorsList = res.data;
          this.exerciseTotal = res.total
        }
      })
    },
    isRecordListOrErrorsList() {
      // console.log()
      if (this.exercise) {
        this.getExerciseRecordList()
      } else {
        this.getExerciseErrorsList()
      }
    },
    exerciseCurrentChange(page) {
      this.exercisePageNum = page
      if (this.exercise) {
        this.getExerciseRecordList()
      } else {
        this.getExerciseErrorsList()
      }
    },
    //做题记录 查看结果
    viewResults(exerciseId, exerciseCate, recordId) {
      console.log('dsad', exerciseCate)
      //先判断是否是私有课程
      if (exerciseCate == 1) {
        this.$router.push({
          path: "/practiceResult",
          query: {
            exerciseId: exerciseId,
            recordId: recordId
          }
        });
      } else {
        //请求获取配置看结果展示配置
        let data = {
          exerciseId: exerciseId
        };
        getEntpExerciseConfigCurrent(data).then(res => {
          if (res.data.resultShow == 1) {
            this.$router.push({
              path: "/practiceResult",
              query: {
                exerciseId: exerciseId,
                recordId: recordId
              }
            });
          } else {
            this.$router.push({
              path: "/otherPracticeRerult",
              query: {
                exerciseId: exerciseId,
                recordId: recordId
              }
            });
          }
        })
      }

    },
    //做题记录 再做一次
    getAgainExam(exerciseId, courseId, exerciseCate, resultShow) {
      let data = {
        exerciseId: exerciseId,
        courseId: courseId,
      };
      exerciseDetailVerification(data).then(res => {
        if (res.success) {
          this.$router.push({
            path: "/examDetail",
            query: {
              exerciseId: exerciseId,
              courseId: courseId,
              exerciseCate,
              exerciseCate,
              resultShow,
              resultShow
            }
          });
        } else {
          this.$alert(res.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      })

    },
    getAgainTest(exerciseId, courseId, noticeContent, isNotice, examTimeStart, examTimeEnd, anyTimeExam, lateDelay, passScore, score) {
      this.exerciseIdOneMore = exerciseId
      this.courseIdOneMore = courseId
      this.nowTime = Date.parse(new Date());
      this.timeStart = Date.parse(new Date(examTimeStart));
      this.timeEnd = Date.parse(new Date(examTimeEnd));
      this.canAnyTimeExam = anyTimeExam;
      this.canLateDelay = lateDelay;
      this.passScore = passScore;
      this.score = score;
      this.dialogVisible = true
      this.noticeContent = noticeContent
      if (isNotice == 0) {
        this.dialogVisible = true
      } else {
        this.goToTest()
      }
    },
    //去往考试页面
    goToTest() {
      let data = {
        id: this.exerciseIdOneMore
      };
      exerciseDetail(data).then(res => {
        this.passScore = res.data.passScore
        let testData = {
          exerciseId: this.exerciseIdOneMore,
          courseId: this.courseIdOneMore,
          timeStart: this.timeStart * 3 + 123456,
          timeEnd: this.timeEnd * 3 + 123456,
          canAnyTimeExam: this.canAnyTimeExam,
          canLateDelay: this.canLateDelay,
          passScore: res.data.passScore,
        }
        localStorage.setItem("testData", JSON.stringify(testData))
        this.$router.push({
          path: "/testDetail",
        });
      })
    },
    //查看错题
    viewMistakesDetail(exerciseId) {
      this.$router.push({
        path: "/mistakesDetail",
        query: {
          exerciseId: exerciseId
        }
      });
    },
    //查看图片
    viewPhoto(url, regId) {
      console.log(url, regId)
      this.img_showBig = true
      this.img_photoUrl = url
      this.regId = regId
    },
    changeCourseType() {
      if (this.courseType == "专业课程") {
        this.getMyCoursePackage(0)
        // this.getMyCoursePackage(1)
      } else {
        this.getQualityAndIntensiveCourseList();
      }
    },
    changeCourseType2() {
      if (this.courseType2 == "专业课程") {
        // this.getMyCoursePackage(0)
        this.getMyCoursePackage(1)
      } else {
        this.getQualityAndIntensiveCourseList2();
      }
    },
    getQualityAndIntensiveCourseList() { //课程列表
      this.studyCentreList = [];
      let data = {
        courseSingleType: this.courseType == "精品课程" ? "0" : "1",
        packagebagStatus:0
      }
      getQualityAndIntensiveCourseList(data).then(res => {
        if (res.code == 200) {
          this.studyCentreList = res.data
        }
      })
    },
    getQualityAndIntensiveCourseList2() { //课程列表
      this.studyCentreList = [];
      let data = {
        courseSingleType: this.courseType2 == "精品课程" ? "0" : "1",
        packagebagStatus:1
      }
      getQualityAndIntensiveCourseList(data).then(res => {
        if (res.code == 200) {
          this.pastCentreList = res.data
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/studyCentre/studyCentre.js